import { render, staticRenderFns } from "./CustodyForm.vue?vue&type=template&id=14f917b7&"
import script from "./CustodyForm.vue?vue&type=script&lang=js&"
export * from "./CustodyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports